import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useInvalidateCache } from "~hooks/useInvalidateCache.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";
import { isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";

export const useDeleteEntity = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();
  const { mutateAsync: invalidateCache } = useInvalidateCache();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (entityId: string) =>
      await request(`${sport}/o/${organizationId}/entities/${entityId}`, {
        method: "DELETE",
      }),
    onSuccess: async (response) => {
      if (!isDefaultOperationSucceeded(response)) {
        return;
      }

      await Promise.all([invalidateCache(), queryClient.invalidateQueries({ queryKey: ["entities", sport, organizationId] })]);
    },
  });
};
